module.exports = new __parcel__URL__("homeButton.398fe35a.png").toString();